import { useState, useEffect } from "react";
import { getLoggedinUser } from "../helpers/api_helper";

const useProfile = () => {
  const [loading, setLoading] = useState(true); // Start with loading state
  const [userProfile, setUserProfile] = useState(null); // Initialize userProfile as null
  const [error, setError] = useState(null); // Add error handling

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const user = getLoggedinUser(); // Fetch logged-in user
        if (user) {
          setUserProfile(user); // Set user profile if available
        }
      } catch (err) {
        console.error("Error fetching user profile:", err);
        setError(err.message || "Failed to fetch user profile"); // Handle errors
      } finally {
        setLoading(false); // Stop loading regardless of success or failure
      }
    };

    fetchUserProfile(); // Call the function to fetch user profile
  }, []); // Empty dependency array ensures this runs once on mount

  return { userProfile, loading, error }; // Return all relevant states
};

export { useProfile };